package uz.ferro.erp.navigator

import kotlinx.browser.window
import uz.ferro.erp.RouterProvider
import uz.ferro.erp.navigator.NavigationPage.*
import web.url.URL
import web.url.URLSearchParams

interface Navigator {

    fun openLogin()

    fun openMain()

    fun openProduct(id: Long, topUpOrderId: Long? = null)

    fun openCountryProducts(id: Long)

    fun openRegionProducts(id: Long)

    fun goBack()

    fun openPage(page: NavigationPage, vararg pathArgs: Any)

    fun openUrl(url: String)

    fun openAdminNewComponentCountry(componentId: Long)

    fun openAdminEditComponentCountry(componentId: Long, componentCountryId: Long)

    fun openAdminNewComponentProduct(productId: Long)

    fun openAdminEditComponentProduct(componentId: Long, componentProductId: Long)
}

class AppNavigator(private val routerProvider: RouterProvider) : Navigator {

    override fun openLogin() {
        val currentUrl = URL(window.location.href)
        val redirect = (currentUrl.pathname + currentUrl.hash).removePrefix("/#")
        val path = "/login?" + URLSearchParams("").apply {
            append("redirect", redirect)
        }

        toLink(path)
    }

    override fun openMain() {
        toLink("/board")
    }

    override fun openProduct(id: Long, topUpOrderId: Long?) {
        var url = "/product/$id"
        if (topUpOrderId != null) {
            url += "?orderId=$topUpOrderId"
        }
        toLink(url)
    }

    override fun openCountryProducts(id: Long) {
        toLink("/products?country=${id}")
    }

    override fun openRegionProducts(id: Long) {
        toLink("/products?region=${id}")
    }

    override fun openAdminNewComponentCountry(componentId: Long) {
        toLink("/admin/component/$componentId/component-country/new")
    }

    override fun openAdminEditComponentCountry(componentId: Long, componentCountryId: Long) {
        toLink("/admin/component/$componentId/component-country/$componentCountryId")
    }

    override fun openAdminNewComponentProduct(componentId: Long) {
        toLink("/admin/component/$componentId/component-product/new")
    }

    override fun openAdminEditComponentProduct(componentId: Long, componentProductId: Long) {
        toLink("/admin/component/$componentId/component-product/$componentProductId")
    }

    override fun goBack() {
        routerProvider.getRouter().navigate(-1.0)
    }

    override fun openPage(page: NavigationPage, vararg pathArgs: Any) {
        val path = when (page) {
            LOGIN -> "/login"
            ADMIN_ORDER -> "/admin/order"
            ADMIN_HOME -> "/admin/home"
            ADMIN_USER -> "/admin/user"
            ADMIN_USER_NEW -> "/admin/user/new"
            ADMIN_PRODUCT -> "/admin/product"
            ADMIN_PRODUCT_NEW -> "/admin/product/new"
            ADMIN_EXCHANGE_RATE -> "/admin/exchange-rate"
            ADMIN_SETTINGS -> "/admin/settings"
            ORDER_LIST -> "/orders"
            ORDER_DETAILS -> "/order"
            TOP_UP -> "/topup"
            FAQ -> "/faq"
            SUPPORT -> "/support"
            VISIT -> "/board/visit"
            CUSTOMER -> "/board/customer"
            USER -> "/board/user"
            TASK -> "/board/task"
        }

        val suffix = pathArgs.joinToString(separator = "/").let {
            if (it.isNotEmpty()) {
                "/$it"
            } else {
                it
            }
        }

        toLink(path + suffix)
    }

    override fun openUrl(url: String) {
        if (isInternalUrl(url)) {
            toLink(url)
        } else {
            openExternal(url)
        }
    }

    private fun toLink(link: String) {
        routerProvider.getRouter().navigate(link)
    }

    private fun openExternal(url: String) {
        window.open(url, "_blank", "noreferrer")
    }

    private fun isInternalUrl(url: String): Boolean {
        if (url.startsWith("/admin/help/")) return true

        return false
    }
}